var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"card mb-4"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('item-material-table')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('div',{staticClass:"d-flex justify-content-between container-fluid"},[_c('div',{staticClass:"text-muted fs-19"},[_c('strong',[_vm._v("Materiais")])])])])
}]

export { render, staticRenderFns }